import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Style from "./Header.module.css";
import logo from "../../assets/hanshi/full-sm.svg";
import Breadcrumbs from "../controls/breadcrumb/Breadcrumb";
import Search from "./CustomSearch";
import TopBarUserIcon from "./TopbarUserIcon";
import Logo from "../logo/Logo";
import { callLogout } from "../../store/actions/auth.actions";
import Avatar from "../../components/controls/avatar/Avatar";
import styles from "./HeaderStyles.module.scss";
import { AlarmIcon, BellIcon, MessageIcon } from "../../modules/default-svg";
import Drawer from "../controls/drawer/Drawer";
import NotificationsDrawer from "../notificationsDrawer/NotificationsDrawer";
import RemindersDrawer from "../remindersDrawer/RemindersDrawer";
import NotificationModals from "../notificationsDrawer/NotificationsModals";
import { Badge } from "@fluentui/react-components";
import {
  notificationsList,
  reminders,
  createdReminders
} from "../../store/selectors/general.selector";
import { DateSelector } from "./Events/DateSelector/DateSelector";
import { getReminders } from "../../store/actions/general.actions";
import VoiceAssistant from "../voiceAssistant/VoiceAssistant";
import MakeSureIcon from "../../assets/svg/MakeSure.svg";
import MakeSureIconFilled from "../../assets/svg/MakeSureFilled.svg";
import MakeSure from "../../views/makeSure/MakeSure";
import { X } from "lucide-react";
import { use } from "react";

const Header = (props) => {
  const { user, getLogo } = props;
  const [show, setShow] = useState(false);
  const [userInfo, setUserInfo] = useState(JSON.parse(user));
  const dispatch = useDispatch();
  const history = useHistory();
  const envr = process.env.REACT_APP_ENV;
  const popoverRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState("");
  const [modalType, setModalType] = useState("");
  const [isCreate, setIsCreate] = useState(true);

  const remindersList = useSelector(reminders);
  const dueReminders = remindersList && typeof remindersList !== "string" ? remindersList : [];
  const remindersCount = dueReminders.length > 0 ? dueReminders.filter((r) => !r.isRead).length : 0;

  const createdRemindersList = useSelector(createdReminders);
  const createdByMeReminders = createdRemindersList && typeof createdRemindersList !== "string" ? createdRemindersList : [];
  const createdRemindersCount = createdByMeReminders.length > 0 ? createdByMeReminders.length : 0;

  let notificationlist = useSelector(notificationsList);
  notificationlist = notificationlist && typeof notificationlist !== "string" ? notificationlist : [];
  const notificationcount = notificationlist.length > 0 ? notificationlist.filter((r) => !r.isRead).length : 0;
  const path = window.location.pathname;

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logoClicked = () => {
    history.push(`/${envr}/dashboard`);
  };

  const handleLogout = () => {
    dispatch(callLogout());
    history.push("/");
  };

  const handleAccountInfo = () => {
    history.push(`/account`);
  };

  useEffect(() => {
    setUserInfo(JSON.parse(user));
  }, [user]);

  const refreshReminders = () =>{
    dispatch(getReminders());
  }

  const [makeSureOpen, setMakeSureOpen] = useState(false);
  const [makeSurePos, setMakeSurePos] = useState({ top: 0, left: 0 });
  const [makeSureIsDragging, setMakeSureIsDragging] = useState(false);
  const [makeSureDragOffset, setMakeSureDragOffset] = useState({ x: 0, y: 0 });
  const [makeSureSize, setMakeSureSize] = useState({ width: 550, height: 650 });
  const [makeSureIsResizing, setMakeSureIsResizing] = useState(false);
  const makeSureResizeAnchor = useRef({ x: 0, y: 0, width: 0, height: 0 });
  const makeSurePanelRef = useRef(null);
  const makeSureTriggerRef = useRef(null);
  const makeSureDragHandleRef = useRef(null);

  const handleMakeSureToggle = useCallback(() => {
    setMakeSureOpen(prev => {
      if (!prev && makeSureTriggerRef.current) {
        const rect = makeSureTriggerRef.current.getBoundingClientRect();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const idealLeft = rect.right - makeSureSize.width;
        const idealTop = rect.bottom + 8;
        setMakeSurePos({
          top: Math.min(Math.max(8, idealTop), vh - makeSureSize.height - 8),
          left: Math.min(Math.max(8, idealLeft), vw - makeSureSize.width - 8),
        });
      }
      return !prev;
    });
  }, [makeSureSize]);

  const handleMakeSureDragStart = useCallback((e) => {
    if (
      (e.target === makeSureDragHandleRef.current ||
        makeSureDragHandleRef.current?.contains(e.target)) &&
      !e.target.closest('button')
    ) {
      setMakeSureIsDragging(true);
      const rect = makeSurePanelRef.current.getBoundingClientRect();
      setMakeSureDragOffset({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    }
  }, []);

  const handleMakeSureDragMove = useCallback((e) => {
    if (makeSureIsDragging && makeSurePanelRef.current) {
      e.preventDefault();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      setMakeSurePos({
        top: Math.min(Math.max(0, e.clientY - makeSureDragOffset.y), vh - makeSureSize.height),
        left: Math.min(Math.max(0, e.clientX - makeSureDragOffset.x), vw - makeSureSize.width),
      });
    }
  }, [makeSureIsDragging, makeSureDragOffset, makeSureSize]);

  const handleMakeSureDragEnd = useCallback(() => {
    setMakeSureIsDragging(false);
  }, []);

  useEffect(() => {
    if (makeSureIsDragging) {
      document.addEventListener('mousemove', handleMakeSureDragMove);
      document.addEventListener('mouseup', handleMakeSureDragEnd);
      return () => {
        document.removeEventListener('mousemove', handleMakeSureDragMove);
        document.removeEventListener('mouseup', handleMakeSureDragEnd);
      };
    }
  }, [makeSureIsDragging, handleMakeSureDragMove, handleMakeSureDragEnd]);

  const handleMakeSureResizeStart = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    makeSureResizeAnchor.current = {
      x: e.clientX,
      y: e.clientY,
      width: makeSurePanelRef.current.offsetWidth,
      height: makeSurePanelRef.current.offsetHeight,
    };
    setMakeSureIsResizing(true);
  }, []);

  const handleMakeSureResizeMove = useCallback((e) => {
    if (makeSureIsResizing) {
      const { x, y, width, height } = makeSureResizeAnchor.current;
      setMakeSureSize({
        width: Math.max(380, width + e.clientX - x),
        height: Math.max(300, height + e.clientY - y),
      });
    }
  }, [makeSureIsResizing]);

  const handleMakeSureResizeEnd = useCallback(() => {
    setMakeSureIsResizing(false);
  }, []);

  useEffect(() => {
    if (makeSureIsResizing) {
      document.addEventListener('mousemove', handleMakeSureResizeMove);
      document.addEventListener('mouseup', handleMakeSureResizeEnd);
      return () => {
        document.removeEventListener('mousemove', handleMakeSureResizeMove);
        document.removeEventListener('mouseup', handleMakeSureResizeEnd);
      };
    }
  }, [makeSureIsResizing, handleMakeSureResizeMove, handleMakeSureResizeEnd]);

  return (
    <>
      <header className={styles.headerWrapper} ref={popoverRef}>
        <div className={styles.headerContent}>
          <div className="logoSection d-flex align-items-center">
            <div className={styles.logoIconWrapper} onClick={logoClicked}>
              <img src={logo} alt="logo" />
            </div>
            <VoiceAssistant />
            {!path.includes("reminders") && !path.includes("notifications") && (
              <Breadcrumbs />
            )}
          </div>
          <div className={styles.headerRightBar}>
            {/* <Search /> */}
            <div className={styles.iconsWrapper}>
              <div className="p-1 cursor-pointer">
                <DateSelector onDateRangeChange={() => { }} />
              </div>
              <div className="p-1 cursor-pointer">
                <MessageIcon />
              </div>
              <div className="p-1 cursor-pointer">
                <Drawer
                  DrawerTrigger={
                    <div className="d-flex" onClick={refreshReminders}>
                      <span style={{ position: "relative" }}>
                        <AlarmIcon />
                      </span>
                      <span
                        style={{
                          position: "absolute",
                          top: "1px",
                          marginLeft: "15px",
                        }}
                      >
                        {remindersCount > 0 && (
                          <Badge
                            className={`CounterBadgeWrap_small CounterBadgeWrap`}
                            appearance="filled"
                            size="small"
                            shape="circular"
                          >
                            {remindersCount}
                          </Badge>
                        )}
                      </span>
                    </div>
                  }
                  DrawerTitle="Reminders"
                  DrawerBodyArea={
                    <RemindersDrawer
                      dueReminders={dueReminders}
                      createdByMeReminders={createdByMeReminders}
                      setIsModalOpen={setIsModalOpen}
                      setReminder={setNotification}
                      modalType={setModalType}
                      setIsCreate={setIsCreate}
                    />
                  }
                />
              </div>
              <div className="p-1 cursor-pointer">
                <Drawer
                  DrawerTrigger={
                    <div className="d-flex">
                      <span style={{ position: "relative" }}>
                        <BellIcon />
                      </span>
                      <span
                        style={{
                          position: "absolute",
                          top: "1px",
                          marginLeft: "15px",
                        }}
                      >
                        {notificationcount > 0 && (
                          <Badge
                            className={`CounterBadgeWrap_small CounterBadgeWrap`}
                            appearance="filled"
                            size="small"
                            shape="circular"
                          >
                            {notificationcount}
                          </Badge>
                        )}
                      </span>
                    </div>
                  }
                  DrawerTitle="Notifications"
                  DrawerBodyArea={
                    <NotificationsDrawer
                      setIsModalOpen={setIsModalOpen}
                      setNotification={setNotification}
                      modalType={setModalType}
                    />
                  }
                />
              </div>
              <div className="p-1 cursor-pointer" ref={makeSureTriggerRef}>
                <img
                  src={makeSureOpen ? MakeSureIconFilled : MakeSureIcon}
                  alt="Make Sure"
                  title="Make Sure"
                  style={{ width: 22, height: 22 }}
                  onClick={handleMakeSureToggle}
                />
              </div>
              <TopBarUserIcon
                show={show}
                handleToggle={setShow}
                user={userInfo}
              />
            </div>
          </div>

          {show && (
            <div className={Style.profileCard}>
              <div className={`${Style.logoWrapper}`}>
                <Logo cssClass={Style.logoStyle} logo={getLogo} />
                <p className="text-xsm-400" onClick={handleLogout}>
                  Sign out
                </p>
              </div>
              <div className={Style.profileWrapper}>
                {userInfo.profilePictureUrl !== null ? (
                  <img
                    src={userInfo.profilePictureUrl}
                    className={Style.profilePiCard}
                    alt=""
                  />
                ) : (
                  <Avatar
                    name={userInfo ? userInfo.fullName : ""}
                    cssClass={Style.initialsAvatar}
                  />
                )}
                <div className={Style.userInfoWrapper}>
                  <p className="text-md-600">
                    {userInfo ? userInfo.fullName : ""}
                  </p>
                  <p className="mb-2 text-xsm-400">
                    {userInfo ? userInfo.email : ""}
                  </p>
                  <p className="mb-0 text-xsm-400" onClick={handleAccountInfo}>
                    My account
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
      {makeSureOpen && (
        <div
          ref={makeSurePanelRef}
          className={`makeSurePanel${makeSureIsDragging ? ' makeSurePanel--dragging' : ''}${makeSureIsResizing ? ' makeSurePanel--resizing' : ''}`}
          style={{
            position: 'fixed',
            top: `${makeSurePos.top}px`,
            left: `${makeSurePos.left}px`,
            width: `${makeSureSize.width}px`,
            height: `${makeSureSize.height}px`,
            zIndex: 1000,
            '--ms-height': `${makeSureSize.height}px`,
            '--ms-width': `${makeSureSize.width}px`,
          }}
        >
          <div
            ref={makeSureDragHandleRef}
            className="makeSurePanel__header"
            onMouseDown={handleMakeSureDragStart}
            style={{ cursor: makeSureIsDragging ? 'grabbing' : 'grab' }}
          >
            <span className="makeSurePanel__title">Make Sure</span>
            <button
              className="makeSurePanel__close"
              onClick={() => setMakeSureOpen(false)}
              title="Close"
              onMouseDown={(e) => e.stopPropagation()}
            >
              <X size={16} />
            </button>
          </div>
          <div className="makeSurePanel__body">
            <MakeSure />
          </div>
          <div
            className="makeSurePanel__resize-grip"
            onMouseDown={handleMakeSureResizeStart}
          />
        </div>
      )}
      {isModalOpen && (
        <NotificationModals
          setIsModalOpen={setIsModalOpen}
          notification={notification}
          modalType={modalType}
          isCreate={isCreate}
        />
      )}
    </>
  );
};

export default Header;
